import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  to, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  fullWidth = false,
  className = '',
  ...props 
}) => {
  const baseClasses = "inline-block font-bold text-center transition-all duration-300 rounded-full";
  
  const variants = {
    primary: "bg-secondary text-primary hover:bg-secondary/90",
    secondary: "bg-transparent border-2 border-secondary text-secondary hover:bg-secondary hover:text-primary",
    accent: "bg-accent text-primary hover:bg-accent/90",
    dark: "bg-dark text-accent hover:bg-dark/90"
  };
  
  const sizes = {
    small: "px-4 py-2 text-sm",
    medium: "px-6 py-3",
    large: "px-8 py-4 text-lg"
  };
  
  const widthClass = fullWidth ? "w-full" : "";
  
  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  
  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  
  return (
    <button className={classes} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;